import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { checkAttachmentType } from '../../../utils/checkAttachments';
import styles from './styles.module.scss';
import { ChatMessageProviderBase } from './ui/ChatMessageProviderBase/ChatMessageProviderBase';
import { LabResultsAttachments } from './ui/LabResultsAttachments/LabResultsAttachments';
import { ProviderAttachmentPostVisit } from './ui/ProviderAttachmentPostVisit/ProviderAttachmentPostVIsit';
import { ProviderAttachmentVerified } from './ui/ProviderAttachmentVerified/ProviderAttachmentVerified';
import { ProviderIntroChatMessage } from './ui/ProviderIntroChatMessage/ProviderIntroChatMessage';
const ChatMessageProvider = ({ message, actions, onActionClick, onAttachmentClick, showTimestamp = true, consultation, }) => {
    const role = $auth.role;
    let isOutcome = message.role_id === role.id || message.isDraft;
    const leftContainerClass = styles.leftMessageContainer;
    const rightContainerClass = cn(styles.rightMessageContainer, styles.rightMessageContainerProvider);
    const containerClass = isOutcome ? rightContainerClass : leftContainerClass;
    if (message.attachments && message.attachments.length > 0) {
        if (checkAttachmentType(message, 'attachment_requirement')) {
            return _jsx(ProviderIntroChatMessage, { consultation: consultation, onActionClick: onActionClick });
        }
        if (checkAttachmentType(message, 'attachment_requirement_verified')) {
            return _jsx(ProviderAttachmentVerified, { message: message, containerClass: rightContainerClass });
        }
        if (checkAttachmentType(message, 'post_visit_notes') ||
            checkAttachmentType(message, 'medication_prescription')) {
            return (_jsx(ProviderAttachmentPostVisit, { message: message, containerClass: rightContainerClass, consultation: consultation }));
        }
        return (_jsx("div", Object.assign({ className: cn(isOutcome && styles.rightMessageContainer, !isOutcome && styles.leftMessageContainer) }, { children: _jsx(LabResultsAttachments, { message: message, consultation: consultation, onAttachmentClick: onAttachmentClick, containerClass: rightContainerClass, isOutcome: isOutcome }) })));
    }
    return (_jsx(ChatMessageProviderBase, { message: message, actions: actions, onActionClick: onActionClick, showTimestamp: showTimestamp, containerClass: containerClass, isOutcome: isOutcome }));
};
export default observer(ChatMessageProvider);
